<template>
  <div id="area" class="mt-20">
    <p class="form-intro">配信停止をご希望のメールアドレスを入力し「配信を停止する」ボタンを押してください。</p>
    <div :class="$style.form">
      <Form @submit="onSubmit">
        <FormWrapHasTitle>
          <FormSection>
            <template #title>メールアドレス</template>
            <template #content>
              <ITextField v-model="formData.email" name="メールアドレス" type="email" rules="required|email|max:200" />
            </template>
          </FormSection>
        </FormWrapHasTitle>
        <div :class="$style.button">
          <IButton type="primary" native-type="submit" flexible center>配信を停止する</IButton>
        </div>
      </Form>
    </div>
    <p :class="$style.note">会員の方は、<a href="/signin">ログイン</a>の上「マイページ &gt; メール受信設定」からお手続きください。</p>
  </div>
</template>

<script setup lang="ts">
import { Form } from 'vee-validate';
import { reactive } from 'vue';
import { unsubscribe, type UnsubscribeData } from '@/js/lib/api/newsletter/unsubscribe';
import { confirm, info, loading } from '@/js/lib/ui';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';
import FormSection from '@/js/components/organisms/FormSection.vue';
import FormWrapHasTitle from '@/js/components/organisms/FormWrapHasTitle.vue';

const formData = reactive<UnsubscribeData>({
  email: '',
});
const onSubmit = async () => {
  if (await confirm('iichi通信の配信を停止します。\nよろしいですか？')) {
    loading({
      asyncFunc: async () => {
        try {
          await unsubscribe(formData);
          info('配信を停止しました', { fadeOut: true });
        } catch (error) {
          info(error.response.data.errors.join('\n'), { fadeOut: false });
        }
      },
    });
  }
};
</script>

<style module lang="scss">
.form {
  margin-bottom: 30px;
  max-width: 600px;
}

.button {
  margin: 14px 0 0;

  @media (--pc) {
    width: 422px;
  }
}

.note a {
  text-decoration: underline;
}
</style>
